module.exports = __webpack_public_path__ + "assets/img/per-90de80d0.png";